import styled from '@emotion/styled';
import { Page } from 'components/Page';
import { Box } from '@mui/material';

const StyledBox = styled(Box)`
  border: 1px solid blue;
  img src="https://source.boomplaymusic.com/group10/M00/06/04/7b79e564220c4f12ac27c863a815ddda_320_320.jpg";
`; 

export const About = () => <Page title="About Us">
  <StyledBox>
    <p>albums</p>
  </StyledBox>
</Page>;